import {React, Link} from 'utils';
import './activestands.less'


/**
 * @return {null}
 */
export function StandCard({data})
{
	if (!data.pavilions.length)
	{
		return null;
	}

	let firstPavilionSlug = data.pavilions[0].slug;
	let pavilionsNames = data.pavilions.map((pavilion) => pavilion.name).join(' | ');

	let chatClasses = [];
	if (data.chatEnabled)
		chatClasses.push("chat");
	else
		chatClasses.push("no-chat");

	if (data.chatOnline)
		chatClasses.push("online");
	else
		chatClasses.push("offline");

	return <div className="col-md-3">
		<div className="stand-box">
			<div className="card">
				<Link to={'/pavilion/' + firstPavilionSlug + '/stand/' + data.slug}>
					<div className="card-body">
						<div className="row">
							<div className="col-9">
								<div className="title-container">
									<span className={chatClasses.join(" ")}/>
									<h4>{data.title}</h4>
								</div>
								<div className="pavilion">{pavilionsNames}</div>
							</div>
							<div className="col-3 text-right">
								<i className="fa fa-angle-right fa-3x"/>
							</div>
						</div>
					</div>
				</Link>
			</div>
		</div>
	</div>
}


/**
 * @return {null}
 */
export function ActiveStands({data})
{

	if (data && data.length > 0)
	{

		let stands = data.map(function (item) {
			return <StandCard key={item.id} data={item}/>
		});

		return (
			<div className="active-stands">
				<div className="row">{stands}</div>
			</div>
		)
	}
	else
	{
		return null;
	}
}


// WEBPACK FOOTER //
// ./src/modules/components/activestands.js